import { render, staticRenderFns } from "./safetyPermitMaintenanceDiagnosisResultDetail.vue?vue&type=template&id=ff16c26a&scoped=true"
import script from "./safetyPermitMaintenanceDiagnosisResultDetail.vue?vue&type=script&lang=js"
export * from "./safetyPermitMaintenanceDiagnosisResultDetail.vue?vue&type=script&lang=js"
import style0 from "./safetyPermitMaintenanceDiagnosisResultDetail.vue?vue&type=style&index=0&id=ff16c26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff16c26a",
  null
  
)

export default component.exports